module.exports = __webpack_public_path__ + "docs/img/cloud-IDE.d6811edf.jpg";